import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/business/leads/")({
    beforeLoad: ({ search }) => {
        throw redirect({ to: "/sales/leads", search, replace: true });
    },
});
